import React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {usuario} from '../redux/actions.js';
import {useDispatch} from 'react-redux';




const users=[
	{label:"Administracion",value:"Administracion"},
	{label:"Ventas",value:"Ventas"},
	{label:"Contabilidad",value:"Contabilidad"},
	{label:"CFC SYSTEMS",value:"Cesarin"},	
];	 

export default function ComboSearch(){
	const dispatch=useDispatch();

	const handleChange=(e)=>{ dispatch(usuario(e.target.value)) }




	return(
		<div>
			<FormControl fullWidth  sx={{ m: 1, maxWidth: 180 }} size="small">
        		<InputLabel >usuario</InputLabel>
        		<Select id="user"  label="usuario" onChange={handleChange}>
        			{users.map(ele=><MenuItem key={ele.value} value={ele.value}>{ele.label}</MenuItem>)}
        		</Select>
      		</FormControl>
		</div>
	)

}